<template>
  <div>
    <core-grid ref="grid" flat modal :onRead="onRead" :schema="schema" />
    <SimulacaoEditGarantiaEdit ref="editar" @close="handleGarantia"/>
  </div>
</template>

<script>
export default {
  components: {
    SimulacaoEditGarantiaEdit: () => import('./SimulacaoEditGarantiaEdit'),
  },
  props: {
    value: null,
  },
  data () {
    return {

    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    schema () {
      return [
        { value: 'TipoPlaca', text: 'Tipo Placa', values: this.$aux.TipoPlaca },
        { value: 'UFLicenciamento', text: 'UF Licenciamento' },
        { value: 'VlrRegistro', text: 'Valor do Registro', format: 'decimal' }
      ]
    }
  },
  methods: {
    onRead: function (options) {
      const th = this
      options.success(th.model.GarantiaSimulacao)
    },
    handleGarantia (acao, data) {
      if (acao === 'save') {
        this.model.GarantiaSimulacao.push(data)
      } else if (acao === 'edit') {
        var index = this.model.GarantiaSimulacao.indexOf(p => p.CodigoSimulacaoGarantia === data.CodigoSimulacaoGarantia)
        this.model.GarantiaSimulacao = this.model.GarantiaSimulacao.filter(p => p.CodigoSimulacaoGarantia !== data.CodigoSimulacaoGarantia)
        this.model.GarantiaSimulacao.splice(index, 0, data)
      }
      this.refresh()
    },
    refresh () {
      this.$refs.grid.refresh()
    },
    excluir (current) {
      if (current) {
        this.model.GarantiaSimulacao = this.model.GarantiaSimulacao.filter(p => p.CodigoSimulacaoGarantia !== current.CodigoSimulacaoGarantia)
        this.refresh()
      }
    }
  }
}
</script>
